import Rule from './Rule'
import classNames from 'classnames'
import FilterList2 from './FilterList2'
import React from 'react'
import './Group.scoped.scss'
import { Select, MenuItem } from '@mui/material'
import { Backdrop } from '@material-ui/core'
import { trackEvent } from 'Shared/lib/posthog'

export default function Group({ id, showAnyAll = true, inset }) {
  const { operator, not, ruleIds } = useSel((s) => s.rules.entities[id])
  const act = useAct()
  const [isModalOpen, setIsModalOpen] = useState(false)

  const openFilterModal = (e) => {
    e.stopPropagation()
    if (!isModalOpen) {
      setIsModalOpen(true)
    }
    trackEvent('audience_builder_adding_rule', {
      type: 'filter',
    })
  }

  const addNestedGroup = (e) => {
    e.stopPropagation()
    act.search.addGroup(id)
    trackEvent('audience_builder_added_rule', {
      type: 'group',
    })
  }

  return (
    <div
      className={classNames('group-container', {
        inset,
      })}
    >
      {showAnyAll ? (
        <div className="filter naked">
          <div className="components">
            {!!inset && (
              <div className="parameter">
                <Select
                  value={!!not}
                  onChange={(v) => act.search.upsertRule(id, { not: v.target.value })}
                >
                  <MenuItem value={false}>Include</MenuItem>
                  <MenuItem value={true}>Exclude</MenuItem>
                </Select>
              </div>
            )}
            <p className="label">
              {!inset && <>{not ? <b>Exclude</b> : <b>Include</b>} </>}everyone who
              matches
            </p>
            <div className="parameter">
              <Select
                value={operator}
                onChange={(e) => act.search.upsertRule(id, { operator: e.target.value })}
              >
                <MenuItem value={'AND'}>all</MenuItem>
                <MenuItem value={'OR'}>any</MenuItem>
              </Select>
            </div>
            <p className="label">of the criteria as selected below</p>
          </div>
        </div>
      ) : null}

      {ruleIds.map((id, i) => (
        <>
          <Rule inset={true} id={id} key={id} />
        </>
      ))}

      <div className="actions">
        <Backdrop open={isModalOpen} classes={{ root: 'cc-backdrop' }} onClick={() => setIsModalOpen(false)}>
          {isModalOpen && (
            <div onClick={(e) => e.stopPropagation()}>
              <FilterList2 groupId={id} close={() => setIsModalOpen(false)}  />
            </div>
          )}
        </Backdrop>
        <button
          id={`buttonRef-${id}`}
          className="button secondary small"
          type="button"
          onClick={openFilterModal}
        >
          <SvgIconsPlus />
          Add filter
        </button>

        <button
          className="button secondary small"
          type="button"
          onClick={addNestedGroup}
        >
          <SvgIconsPlus />
          Add nested group
        </button>
      </div>
    </div>
  )
}
